/* @flow */
import PropTypes from "prop-types";

import * as React from "react";
import Tracking from "../uidispatcherapi/Tracking";

type Props = {
    children?: React.ReactNode;
};

type State = {
    errorOccurred: boolean;
};

class ErrorBoundary extends React.Component<Props, State> {
    static contextTypes = {
        intl: PropTypes.object
    };

    constructor(props: Props) {
        super(props);
        this.state = { errorOccurred: false };
    }
    componentDidCatch() {
        this.setState({ errorOccurred: true });
    }

    render() {
        if (this.state.errorOccurred) {
            // TODO (DaBi): Make message of error-tracking more concrete
            Tracking.trackError("searchdiscover", "ui", "shared", "Some shared component failed to render!");
            return null;
        }
        return <React.Fragment>{this.props.children}</React.Fragment>;
    }
}

export default ErrorBoundary;
